import React, {FC, useState} from "react";
import GatewayService from "../../service/GatewayService";
import {TimeUtil} from "../../util/TimeUtil";
import {Closing} from "../../models/Closing";
import Calendar from "react-calendar";
import '../Calendar.css';

const ClosingPriceComponent: FC = () => {
    const [date, setDate] = useState<string>(TimeUtil.toUIDate(new Date()));
    const [closings, setClosings] = useState<Closing[]>([]);
    const [showCalendar, setShowCalendar] = useState(false);

    function fetchClosings() {
        if (!date) {
            return;
        }
        GatewayService.getClosingPricesByDate(date)
            .then(setClosings)
            .catch(console.error);
    }

    const handleDateChange = (newDate: Date | null | [Date | null, Date | null]) => {
        if (newDate instanceof Date) {
            setDate(TimeUtil.toUIDate(newDate));
            setShowCalendar(false);
        }
    };

    return (
        <div>
            <h2>Closing Prices</h2>
            <input type="text" value={date} onChange={e => setDate(e.target.value)}/>
            <button onClick={() => setShowCalendar(s => !s)}>{showCalendar ? 'Hide' : 'Show'} Calendar</button>
            {showCalendar && <Calendar
                onChange={handleDateChange}
                value={TimeUtil.parseUIDate(date) || new Date()}
            />}
            <button onClick={fetchClosings}>Fetch</button>

            <table>
                <thead>
                <tr>
                    <th>Token</th>
                    <th>Trading Symbol</th>
                    <th>Prev Closing</th>
                    <th>Closing</th>
                    <th>Date</th>
                </tr>
                </thead>
                <tbody>
                {closings.map((closing, index) => (
                    <tr key={index}>
                        <td>{closing.token}</td>
                        <td>{closing.tradingSymbol}</td>
                        <td>{closing.prevClosingPrice}</td>
                        <td>{closing.closing}</td>
                        <td>{closing.date}</td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
}

export default ClosingPriceComponent;
